import { render, staticRenderFns } from "./FilterItemMenu.vue?vue&type=template&id=2f470e7d&scoped=true&"
import script from "./FilterItemMenu.vue?vue&type=script&lang=js&"
export * from "./FilterItemMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f470e7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
